const STORAGE_KEY = 'lccto_engine_last_login_email';
const LEGACY_KEY = 'lastLoginEmail';

export function readLastLoginEmail(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || localStorage.getItem(LEGACY_KEY) || '';
  } catch {
    return '';
  }
}

export function saveLastLoginEmail(email: string): void {
  const normalized = email.trim().toLowerCase();
  if (!normalized) return;

  try {
    localStorage.setItem(STORAGE_KEY, normalized);
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    /* private mode / quota */
  }
}
